import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './SALEPROFIT_Sale_Process.css';

const SALEPROFIT_Sale_Process = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"SALEPROFIT_SALE_PROCESS",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	SALEPROFIT_SALE_PROCESS:-1
  });


  const [SALEPROFIT_SALE_PROCESS, setSALEPROFIT_SALE_PROCESS] = React.useState(null);
  const [SALEPROFIT_SALE_PROCESS_D, setSALEPROFIT_SALE_PROCESS_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Sale Profit Sale Process');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewSALEPROFIT_SALE_PROCESS(clientInfo,"OpenNew");

		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutSALEPROFIT_SALE_PROCESS(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostSALEPROFIT_SALE_PROCESS(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewSALEPROFIT_SALE_PROCESS(clientInfo,"OpenNew");
		}
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
		if(Temp_Data2.status!="New"){
			handleDeleteSALEPROFIT_SALE_PROCESS(Temp_Data2);
			navigate('/SALEPROFIT_Sale_Process#New',{replace:true});
		} 
		else 
			navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Sale_Process',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!SALEPROFIT_SALE_PROCESS) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_${i}_SECTION`;
	  const headerId = `#SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [SALEPROFIT_SALE_PROCESS]) ;


  
  
  var Ids = [];
  for(var Ele in SALEPROFIT_SALE_PROCESS){
	  for(var Sec in SALEPROFIT_SALE_PROCESS[Ele]){
		if(Sec == "id")
			Ids.push(SALEPROFIT_SALE_PROCESS[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(SALEPROFIT_SALE_PROCESS[Ele]["status"]);
		else if(Array.isArray(SALEPROFIT_SALE_PROCESS[Ele][Sec]))
			  for(var Row in SALEPROFIT_SALE_PROCESS[Ele][Sec])  // Convert to SALEPROFIT_SALE_PROCESS[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in SALEPROFIT_SALE_PROCESS[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["SALEPROFIT_SALE_PROCESS"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewSALEPROFIT_SALE_PROCESS(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS`).then((response1) => {
		if(!SALEPROFIT_SALE_PROCESS) 
			setSALEPROFIT_SALE_PROCESS(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS_D`).then((response2) => {
			setSALEPROFIT_SALE_PROCESS_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddSALEPROFIT_SALE_PROCESS_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewSALEPROFIT_SALE_PROCESS = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setSALEPROFIT_SALE_PROCESS(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataSALEPROFIT_SALE_PROCESS = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutSALEPROFIT_SALE_PROCESS = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostSALEPROFIT_SALE_PROCESS = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteSALEPROFIT_SALE_PROCESS = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_SALE_PROCESS', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["1"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("1","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["1"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("1","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["1"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("1","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["1"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("1","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["2"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0"]=value;
	Form_Data_onChange("2","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0",value,Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
  }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["2"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("2","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["2"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("2","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["2"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("2","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["3"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0"]=value;
	Form_Data_onChange("3","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0",value,Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
  }; 
  

const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["4"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0"]=value;
	Form_Data_onChange("4","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
  }; 
  

    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  

const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4"]=value;
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
  }; 
  

    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["5"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("5","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  

const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["9"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0"]=value;
	Form_Data_onChange("9","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
  }; 
  

    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["9"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("9","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["9"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("9","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["9"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("9","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  
    
const SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
	Temp_Data["9"]["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4"]=value;
	//handleAddSALEPROFIT_SALE_PROCESS(Temp_Data,App_Data['SALEPROFIT_SALE_PROCESS']);
	Form_Data_onChange("9","SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_SALE_PROCESS(Temp_Data);
    setSALEPROFIT_SALE_PROCESS(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!SALEPROFIT_SALE_PROCESS) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedSALEPROFIT_SALE_PROCESS =JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
  updatedSALEPROFIT_SALE_PROCESS[Sec] = [...updatedSALEPROFIT_SALE_PROCESS[Sec], newRow];
  setSALEPROFIT_SALE_PROCESS(updatedSALEPROFIT_SALE_PROCESS);
};

const handleDeleteRow = (sec,index) => {
  const updatedSALEPROFIT_SALE_PROCESS = JSON.parse(JSON.stringify(SALEPROFIT_SALE_PROCESS));
  updatedSALEPROFIT_SALE_PROCESS[sec].splice(index, 1);
  setSALEPROFIT_SALE_PROCESS(updatedSALEPROFIT_SALE_PROCESS);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Sale Profit Sale Process`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Sale Profit Sale Process ID`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SALEPROFIT Sale Process ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0" type="text" className="form-control" placeholder="SALEPROFIT Sale Process ID" value={SALEPROFIT_SALE_PROCESS["1"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SALEPROFIT Sale Process ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1" type="text" className="form-control" placeholder="Asset ID" value={SALEPROFIT_SALE_PROCESS["1"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2" type="text" className="form-control" placeholder="Offering ID" value={SALEPROFIT_SALE_PROCESS["1"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Broker ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3" type="text" className="form-control" placeholder="Broker ID" value={SALEPROFIT_SALE_PROCESS["1"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Broker ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Listing Date`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Listing Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0" type="date"  value={SALEPROFIT_SALE_PROCESS["2"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0`]} 
							onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0_Change} style={{ borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Listing Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asking Price USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1" type="text" className="form-control" placeholder="Asking Price USD" value={SALEPROFIT_SALE_PROCESS["2"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Asking Price USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offer Received USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2" type="text" className="form-control" placeholder="Offer Received USD" value={SALEPROFIT_SALE_PROCESS["2"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Offer Received USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Accepted Offer USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3" type="text" className="form-control" placeholder="Accepted Offer USD" value={SALEPROFIT_SALE_PROCESS["2"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Accepted Offer USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Closing Date`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Closing Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0" type="date"  value={SALEPROFIT_SALE_PROCESS["3"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0`]} 
							onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0_Change} style={{ borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_3_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Closing Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Sale Status`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sale Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0"  value={SALEPROFIT_SALE_PROCESS["4"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0`]} onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_4_0_Change} className="form-control" name="Sale Status"  >
						  <option value="Planning">Planning</option>
						  <option value="Listed">Listed</option>
						  <option value="Under Offer">Under Offer</option>
						  <option value="Under Contract">Under Contract</option>
						  <option value="Closed">Closed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sale Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0" type="text" className="form-control" placeholder="Submitted By" value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1" type="text" className="form-control" placeholder="Submitted At" value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2" type="text" className="form-control" placeholder="Reviewed By" value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3" type="text" className="form-control" placeholder="Reviewed At" value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4"  value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4`]} onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5" type="text" className="form-control" placeholder="Approval Notes" value={SALEPROFIT_SALE_PROCESS["5"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0"  value={SALEPROFIT_SALE_PROCESS["9"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0`]} onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1" type="text" className="form-control" placeholder="Created By" value={SALEPROFIT_SALE_PROCESS["9"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2" type="text" className="form-control" placeholder="Created At" value={SALEPROFIT_SALE_PROCESS["9"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3" type="text" className="form-control" placeholder="Updated By" value={SALEPROFIT_SALE_PROCESS["9"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4" type="text" className="form-control" placeholder="Updated At" value={SALEPROFIT_SALE_PROCESS["9"][`SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4`]} 
						onChange={SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_04_ASSET_MANAGER_SALE_PROCESS_EXECUTION_SALEPROFIT_SALE_PROCESS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default SALEPROFIT_Sale_Process;  